import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { buildHttpParams } from 'app/core/utils/http-util';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from '../../../../../environments/environment';
import { EnumSituacao } from '../../../shared/enums/situacao.enum';
import { EnumSituacaoPublicoAlvo } from '../enums/situacao-publico-alvo.enum';
import { IPublicoAlvoFilter } from '../interfaces/publico-alvo-filter.interface';
import { IPopulacaoFilter, IPopulacaoResponse } from '../interfaces/publico-alvo-populacao.interface';
import {
  IPublicoAlvoListItem,
  IPublicoAlvoListOptions,
  IPublicoAlvoListResponse,
  IPublicoAlvoPayload,
  IPublicoAlvoPopulacaoResponse,
  IPublicoAlvoResponse,
} from '../interfaces/publico-alvo-request.interface';
import { IPublicoAlvo } from '../interfaces/publico-alvo.interface';

@Injectable({ providedIn: 'root' })
export class PublicoAlvoApi {
  private readonly apiUrl = `${environment.pathApi}/v1/environment/publicos-alvo`;

  constructor(private http: HttpClient) {}

  search(filter: IPublicoAlvoFilter): Observable<IPublicoAlvoResponse> {
    const { situacoes, ...rest } = filter;
    const params = situacoes === EnumSituacao.TODAS ? rest : filter;
    return this.http.get<IPublicoAlvoResponse>(this.apiUrl, {
      params: buildHttpParams(params),
    });
  }

  list(opcoes: IPublicoAlvoListOptions = {}): Observable<IPublicoAlvoListItem[]> {
    const params: Record<string, boolean> = {};
    if (opcoes.populacao) {
      params.populacao = true;
    }
    if (opcoes.segmentacoes) {
      params.segmentacoes = true;
    }
    return this.http
      .get<IPublicoAlvoListResponse>(`${this.apiUrl}/0/list`, {
        params: buildHttpParams(params),
      })
      .pipe(map((response) => response?.data ?? []));
  }

  fetchPopulacao(ids: number[]): Observable<IPublicoAlvoPopulacaoResponse> {
    return this.http.get<IPublicoAlvoPopulacaoResponse>(
      `${this.apiUrl}/0/populacao`,
      { params: buildHttpParams({ ids }) }
    );
  }

  load(id: number): Observable<IPublicoAlvo> {
    return this.http.get<IPublicoAlvo>(`${this.apiUrl}/${id}`);
  }

  getPopulacao(filter: IPopulacaoFilter): Observable<IPopulacaoResponse> {
    return this.http.get<IPopulacaoResponse>(`${this.apiUrl}/0/populacao`, {
      params: buildHttpParams(filter),
    });
  }

  create(payload: IPublicoAlvoPayload): Observable<IPublicoAlvo> {
    return this.http.post<IPublicoAlvo>(this.apiUrl, payload);
  }

  update(id: number, payload: IPublicoAlvoPayload): Observable<IPublicoAlvo> {
    return this.http.put<IPublicoAlvo>(`${this.apiUrl}/${id}`, payload);
  }

  updateSituacao(id: number, situacao: EnumSituacaoPublicoAlvo): Observable<IPublicoAlvo> {
    return this.http.put<IPublicoAlvo>(`${this.apiUrl}/${id}/situacao`, { situacao });
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }
}
